import React, { useState } from "react";
import classes from "./OtpCaMobileModal.module.scss";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Modal } from "react-bootstrap";
import { FormattedMessage } from "react-intl";
import messages from "./module/messages";
import { CssTextField } from "../../TextInputField/TextInputField";

interface OtpCaMobileModalProps {
  show: boolean;
  size?: "lg" | "xl" | "sm";
  onClose: () => void;
  confirmCaOtpHandler: (otp: string) => void;
}

function OtpCaMobileModal({
  show,
  size,
  onClose,
  confirmCaOtpHandler,
}: OtpCaMobileModalProps) {
  const [otp, setOtp] = useState("");

  const onCloseHandler = () => {
    setOtp("");
    onClose();
  };

  const onConfirmHandler = () => {
    confirmCaOtpHandler(otp);
    setOtp("");
  };

  return (
    <Modal
      show={show}
      size={size ? size : "sm"}
      onHide={onCloseHandler}
      centered
      contentClassName={classes.content}
    >
      <Modal.Header className={classes.header}>
        <Modal.Title style={{ fontSize: "1rem" }}>
          <FormattedMessage {...messages.panelTitle} />
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ fontSize: "0.75rem" }}>
        <div className={classes.selectWrapper}>
          <CssTextField
            className={classes["textfield-input"]}
            key={`otp`}
            id={`otp`}
            label={<FormattedMessage {...messages.otpLabel} />}
            size="small"
            value={otp}
            onChange={(e: any) => setOtp(e.target.value)}
            fullWidth
            variant="filled"
          />
        </div>
      </Modal.Body>
      <Modal.Footer className={classes.footer}>
        <button
          className={`${classes.btn} ${classes["btn-cancel"]}`}
          onClick={onClose}
        >
          <FormattedMessage {...messages.close} />
        </button>
        <button
          disabled={!otp || otp === ""}
          className={`${classes.btn} ${classes["btn-confirm"]}`}
          onClick={onConfirmHandler}
        >
          <FormattedMessage {...messages.confirm} />
        </button>
      </Modal.Footer>
    </Modal>
  );
}

export default OtpCaMobileModal;
